import React from "react"

import { SwatchesPicker } from "react-color"

function ColorPalette({ colors }) {
  return (
    <>
      <SwatchesPicker colors={colors} />
    </>
  )
}

export default ColorPalette
